import {
  ClaimsAdvice,
  ProReportResponse,
  ProVesselTypes,
  RiskLevel,
  VesselSpecificClaimsAdvice,
  isNonVesselTypeSpecificProReport,
} from '../../models/pro.model';

export function getRiskColor(level: RiskLevel) {
  if (level === RiskLevel.HIGH) return 'red';
  if (level === RiskLevel.MEDIUM) return 'orange';
  return 'green';
}

export function getRiskTableData({ report }: { report: ProReportResponse }) {
  if (isNonVesselTypeSpecificProReport(report)) {
    return Object.entries(report.risk_level)
      .filter(([vesselType]) => vesselType !== ProVesselTypes.UNKNOWN)
      .map(([vesselType, riskLevel]) => ({
        vesselType: vesselType as ProVesselTypes,
        riskLevel: riskLevel as RiskLevel,
      }));
  }
  if (!isNonVesselTypeSpecificProReport(report)) {
    return [
      {
        vesselType: report.vessel_type as ProVesselTypes,
        riskLevel: report.risk_level as RiskLevel,
      },
    ];
  }
  return [];
}

export function hasApplicableVesselTypes(
  item: ClaimsAdvice | VesselSpecificClaimsAdvice
): item is ClaimsAdvice {
  return (
    'applicable_vessel_types' in item &&
    Array.isArray(item.applicable_vessel_types)
  );
}
